"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPath = void 0;
exports.default = Path;
var L = require("leaflet");
var createjs = require("@caddigital/easeljs/lib/easeljs");
var CanvasNode_1 = require("./CanvasNode");
var BoundingShape_1 = require("./BoundingShape");
var define = require("./define");
/**
 * TODO: REFACTOR THIS TO OWN FILE
 * convert latlng to point
 * */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
/**
 * Static method to draw instance into given canvas
 */
var drawPath = function (graphics, points, bounds, scale, color) {
    var g = graphics;
    g.clear();
    g.beginStroke(createjs.Graphics.getRGB(0, 0, 0, 0.3))
        .setStrokeStyle(1, 'round', 'bevel', 'round')
        .setStrokeDash([5, 5]);
    if (define.DEBUGGING &&
        bounds.min !== undefined &&
        bounds.max !== undefined) {
        g.drawRect(bounds.min.x - 1, bounds.min.y - 1, bounds.max.x - bounds.min.x + 1, bounds.max.y - bounds.min.y + 1);
    }
    g.beginStroke(color.stroke)
        .beginFill(color.fill)
        .setStrokeStyle(define.LINE_WIDTH * scale, 'round', 'round')
        .setStrokeDash([]);
    for (var i = 0; i < points.length; i++) {
        var point = points[i];
        if (points[i] && i) {
            g.moveTo(points[i - 1].x, points[i - 1].y);
        }
        else {
            g.moveTo(points[i].x - 1, points[i].y);
        }
        g.lineTo(point.x, point.y);
    }
    g.closePath();
};
exports.drawPath = drawPath;
function Path(map, latlngPath, color) {
    var _this = this;
    var zoom = map.getZoom();
    var polyline = L.polyline(latlngPath);
    var rect = polyline.getBounds();
    var origin = map.getPixelOrigin();
    var topLeft = latlngToPoint(map, origin, rect.getNorthWest(), zoom);
    var bottomRight = latlngToPoint(map, origin, rect.getSouthEast(), zoom);
    var box = new L.Bounds([topLeft, bottomRight]);
    var x = topLeft.x;
    var y = topLeft.y;
    var latlng = rect.getNorthWest();
    CanvasNode_1.default.call(this, define.PATH, map, latlng, color.stroke, color.fill);
    var width = Math.max(box.getTopRight().x, box.getBottomRight().x) - x;
    var height = Math.max(box.getBottomLeft().y, box.getBottomRight().y) - y;
    var bounds = { x: x, y: y, width: width, height: height };
    BoundingShape_1.default.call(this, rect, bounds, box);
    this.latlngPath = polyline;
    this.path = latlngPath.map(function (x) { return latlngToPoint(map, origin, x, zoom); });
    this._width = this.width = width;
    this._height = this.height = height;
    if (map.dragging._draggable._newPos) {
        this._offset = map.dragging._draggable._newPos;
    }
    /**
     * recalculate latlng
     */
    this.updateLatLng = function (zoom) {
        var _a = _this, path = _a.path, _map = _a._map;
        var crs = _this._map.options.crs;
        var scale = crs.scale(_this._map.getZoom());
        var _scale = scale / _this._scale;
        var origin = _map.getPixelOrigin();
        var len = path.length;
        var level = zoom || _this._map.getZoom();
        var point = new L.Point(_this.x, _this.y).add(_this._offset.multiplyBy(_scale));
        var diff = new L.Point(_this._x, _this._y).subtract(point);
        var latlngs = [];
        if (_map.dragging._draggable._newPos) {
            origin = origin.subtract(_this._map.dragging._draggable._newPos);
        }
        for (var i = 0; i < len; i++) {
            var p = path[i].add(origin).add(diff);
            latlngs.push(_map.unproject(p, level));
        }
        _this.latlng = _map.unproject(point.add(origin), level);
        _this.latlngPath = L.polyline(latlngs);
    };
    /**
     * recalculate bounding box
     */
    this.updateBoundingBox = function (zoom) {
        var origin = _this._map.getPixelOrigin();
        var level = zoom || _this._map.getZoom();
        _this._bounds = {
            x: _this.x,
            y: _this.y,
            width: _this.width,
            height: _this.height
        };
        var minP = new L.Point(_this.x, _this.y);
        var maxP = new L.Point(_this.x + _this.width, _this.y + _this.height);
        var min = _this._map.unproject(minP.add(origin), level);
        var max = _this._map.unproject(maxP.add(origin), level);
        _this._rect = new L.LatLngBounds(min, max);
        _this._boundingBox = new L.Bounds([
            latlngToPoint(_this._map, origin, _this._rect.getNorthWest(), level),
            latlngToPoint(_this._map, origin, _this._rect.getSouthEast(), level)
        ]);
        // store the actual px value of width and height with the scale factor
        _this._width = bounds.width * _this._scale;
        _this._height = bounds.height * _this._scale;
    };
    /**
     * calculate bounding box related to current zoom level from layer
     * @return {L.Bounds}
     */
    this.getBoundingBox = function () {
        var scale = _this._map.options.crs.scale(_this._map.getZoom());
        return new L.Bounds([
            _this._boundingBox.min,
            _this._boundingBox.max.multiplyBy(scale)
        ]);
    };
    /**
     * Apply transformation to path
     *
     * @param {Array<number>} matrix
     * @param {L.Point} diff
     */
    this._transformPoints = function (matrix, diff) {
        var path = _this.path;
        var len = path.length;
        for (var i = 0; i < len; i++) {
            var point = path[i];
            path[i] = point._add(diff);
        }
    };
    /**
     * Apply transformation matrix to blitted image
     * using double buffering so that we wont blink
     *
     * 1. pre-transform - clear the path out of canvas, copy canvas state
     * 2. at every frame:
     * 	2.1. save
     * 	2.2 redraw the canvas from saved one
     * 	2.3 transform
     * 	2.4 draw path
     * 	2.5 restore
     * 3. repeat
     *
     * @param {Matrix} matrix
     */
    this.transform = function (matrix, rotation) {
        var m = matrix.matrix;
        var diff = new L.Point(m[4] - _this.x, m[5] - _this.y);
        _this._x = _this.x;
        _this._y = _this.y;
        _this.x = m[4];
        _this.y = m[5];
        _this.scaleX = m[0];
        _this.scaleY = m[3];
        _this.skewX = m[1]; // Math.tan(m[1])
        _this.skewY = m[2]; // Math.tan(m[2])
        _this.regX = _this.x; // this.x + this.width / 2
        _this.regY = _this.y; // this.x + this.height / 2
        _this._transformPoints(m, diff);
    };
    this.update = function () {
        _this.updateLatLng();
        _this.updateBoundingBox();
        _this._draw();
    };
    this._draw = function () {
        var g = _this.graphics;
        var points = _this.path;
        var color = {
            stroke: 'rgba(0, 255, 0, 0.8)',
            fill: 'rgba(0, 255, 0, 0.8)'
        };
        if (!_this._selected) {
            color = { stroke: _this.stroke, fill: _this.fill };
        }
        (0, exports.drawPath)(g, points, _this._boundingBox, _this._scale, color);
    };
}
Path.prototype = new createjs.Shape();
